"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _MLKK6UGOcjs = require('./MLKK6UGO.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');

// src/toolbar/toolbar-store.ts
var _toolbarstore = require('@ariakit/core/toolbar/toolbar-store'); var Core = _interopRequireWildcard(_toolbarstore);
function useToolbarStoreProps(store, update, props) {
  return _MLKK6UGOcjs.useCompositeStoreProps.call(void 0, store, update, props);
}
function useToolbarStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createToolbarStore, props);
  return useToolbarStoreProps(store, update, props);
}




exports.useToolbarStoreProps = useToolbarStoreProps; exports.useToolbarStore = useToolbarStore;
